import { PageType } from '@Generated/graphql'

export const pageTypeToDestinationPageType = (type: string) => {
  switch (type) {
    case 'categories': return 'category'
    case 'products': return 'product'
    default: return type
  }
}

export const destinationPageTypeToPageType = (pageType: string) => {
  switch (pageType) {
    case 'category': return 'categories'
    case 'lp': return 'landingpages'
    case 'product': return 'products'
    default: return pageType
  }
}

export const stringToPageType = (type: string): PageType => {
  switch (type) {
    case PageType.Article:
    case 'article':
    case 'articles':
      return PageType.Article
    case PageType.Ambassador:
    case 'ambassador':
    case 'ambassadors':
      return PageType.Ambassador
    case PageType.Category:
    case 'category':
    case 'categories':
      return PageType.Category
    case PageType.Collection:
    case 'collection':
    case 'collections':
      return PageType.Collection
    case PageType.Filter:
    case 'filter':
    case 'filters':
      return PageType.Filter
    case PageType.Landingpage:
    case 'lp':
    case 'landingpage':
    case 'landingpages':
      return PageType.Landingpage
    case PageType.Look:
    case 'look':
    case 'looks':
      return PageType.Look
    case PageType.Manual:
    case 'manual':
    case 'manuals':
      return PageType.Manual
    case PageType.Modal:
    case 'modal':
    case 'modals':
      return PageType.Modal
    case PageType.Product:
    case 'product':
    case 'products':
      return PageType.Product
    default:
      return type as PageType
  }
}

export const cacheKeyToSurrogateKey = (cacheKey: string): string | false => {
  const [type = '', id = ''] = cacheKey.split(':')
  switch (type) {
    // Accounts
    case 'account':
    case 'accounts':
      return `ACC${id}`

    // Ambassadors
    case 'ambassador':
    case 'ambassadors':
      return `AMB${id}`

    // Articles
    case 'article':
    case 'articles':
    case 'cms_category_articles':
      return `ART${id}`

    // Careers
    case 'career':
    case 'careers':
    case 'cms_category_careers':
      return `CAR${id}`

    // Categories
    case 'category':
    case 'categories':
      return `CAT${id}`

    // Collections
    case 'cms_category_collections':
    case 'collections':
      return `COL${id}`

    // CSR
    case 'cms_category_csr':
    case 'csr':
      return `CSR${id}`

    // Frontpages
    case 'cms_category_frontpages':
    case 'frontpage':
    case 'frontpages':
      return `FRO${id}`

    // Landingpages
    case 'landingpage':
    case 'landingpages':
    case 'lp':
      return `LAN${id}`

    // Looks
    case 'look':
    case 'looks':
      return `LOK${id}`

    // Manuals
    case 'cms_category_manuals':
    case 'manual':
    case 'manuals':
      return `MAN${id}`

    // Press
    case 'cms_category_press':
    case 'press':
      return `PRE${id}`

    // Products
    case 'product':
    case 'products':
      return `PRO${id}`

    // Returns
    case 'returns':
      return `RET${id}`

    // Terms
    case 'cms_category_terms':
    case 'terms':
      return `TER${id}`

    // No match
    default:
      return false
  }
}
